export const normalizeCommodityGroups = (groups) => {
  if (!Array.isArray(groups)) return []

  return groups.map((group) => {
    const dateCounters = {}
    const segments = (group.segments || []).map((segment) => {
      const date = (segment['讲解开始时间'] || '').split(' ')[0]
      const dailyIndex = date ? (dateCounters[date] = (dateCounters[date] || 0) + 1) : 0
      return { ...segment, _dailyIndex: dailyIndex }
    })
    const firstSegment = segments[0] || {}

    return {
      ...group,
      productName: group.productName || group.cleanName || firstSegment['商品名称'] || '未知商品',
      talentNickname: group.talentNickname || firstSegment['达人昵称'] || '未知达人',
      productImage: group.productImage || firstSegment['商品图片_本地'] || firstSegment['商品图片'],
      segments,
      recordedSegments: group.recordedSegments ?? segments.filter(item => item['已录制']).length,
      notRecordedSegments: group.notRecordedSegments ?? segments.filter(item => !item['已录制']).length
    }
  })
}
